/**
 * Portal Magic Link Verification
 * Handles magic link callback and creates session
 */

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { verifyMagicLink } from '../services/portalService';
import './PortalLogin.css';

const PortalMagicVerify = () => {
  const { magicToken } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [error, setError] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        const result = await verifyMagicLink(magicToken);
        if (result.success) {
          setStatus('success');
          // Redirect to portal after brief success message
          setTimeout(() => {
            navigate(`/portal/${result.accessToken}`, { replace: true });
          }, 1500);
        } else {
          setStatus('error');
          setError('Invalid or expired link');
        }
      } catch (err) {
        setStatus('error');
        setError(err.message || 'Failed to verify magic link');
      }
    };

    if (magicToken) {
      verify();
    } else {
      setStatus('error');
      setError('Invalid link');
    }
  }, [magicToken, navigate]);

  return (
    <div className="portal-login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-logo">FusionICT Billing</h1>
          <p className="login-subtitle">Partner Portal</p>
        </div>

        {status === 'verifying' && (
          <div className="verify-status">
            <div className="spinner"></div>
            <h2>Verifying your link...</h2>
            <p>Please wait a moment.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verify-status success">
            <div className="status-icon">✓</div>
            <h2>You're signed in!</h2>
            <p>Redirecting to your portal...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="verify-status error">
            <div className="status-icon">✕</div>
            <h2>Link expired or invalid</h2>
            <p>{error}</p>
            <p className="text-small">Magic links expire after 24 hours and can be used once. Please request a new one.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/', { replace: true })}
              style={{ marginTop: '1rem' }}
            >
              Back to Sign In
            </button>
          </div>
        )}

        <footer className="login-footer">
          <p>Secure billing portal by FusionICT</p>
        </footer>
      </div>
    </div>
  );
};

export default PortalMagicVerify;
